export default "__VITE_ASSET__cba3e743__"